import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const rootElement = document.getElementById("root");

// react-snap prerenders pages into static HTML at build time (good for SEO and
// social scrapers). We intentionally render() rather than hydrate(): Ionic's
// Stencil web components produce hydration mismatches that leave the app
// non-interactive. render() replaces the prerendered markup on the client so the
// app is fully interactive, while crawlers still receive the prerendered HTML.
ReactDOM.render(<App />, rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
